module.exports = __webpack_public_path__ + "img/refresh.ec70af9f.svg";